module.exports = __webpack_public_path__ + "media/images/favicon-16386f6972706c57d2e12c4b7ddbc31d.ico";